// TODO: this should be a shared library that can be used in server/api and client/web.
// Currently it cannot be used in server/api as compilation fails for some reason. Likely related to Docker.

export type Coordinates = { lat: number; lng: number };

const toRadian = (degree: number): number => (degree * Math.PI) / 180;

/**
 * Haversine distance using Earth's mean radius (meters). Matches ST_DistanceSphere.
 */
export const haversineDistance = (
  point1?: Coordinates | null,
  point2?: Coordinates | null,
): number => {
  if (!point1 || !point2) return 0;

  const earthRadiusInMeters = 6371008;
  const lat1 = toRadian(point1.lat);
  const lat2 = toRadian(point2.lat);
  const deltaLat = toRadian(point2.lat - point1.lat);
  const deltaLon = toRadian(point2.lng - point1.lng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) *
      Math.cos(lat2) *
      Math.sin(deltaLon / 2) *
      Math.sin(deltaLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return Math.round(earthRadiusInMeters * c);
};

type FirstAndLastName = {
  firstName: string;
  lastName: string;
};

export const getNamesFromEmail = (email: string): FirstAndLastName => {
  const splitEmailWithoutDomainToNames = (
    emailWithoutDomain: string,
    delimiter: string,
  ): FirstAndLastName => {
    const splitEmail = emailWithoutDomain.split(delimiter);
    return {
      firstName: splitEmail[0]?.replace(/[^a-z]/g, ''),
      lastName: splitEmail[1]?.replace(/[^a-z]/g, '') ?? '',
    };
  };

  if (isApplePrivateRelayEmail(email)) {
    return {
      firstName: '',
      lastName: '',
    };
  }
  const delimiters = ['.', '_', '-'];
  const emailWithoutDomain = email.split('@')[0];
  for (const delimiter of delimiters) {
    if (emailWithoutDomain.includes(delimiter)) {
      return splitEmailWithoutDomainToNames(emailWithoutDomain, delimiter);
    }
  }

  return {
    firstName: emailWithoutDomain?.replace(/[^a-z]/g, ''),
    lastName: '',
  };
};

export const generateUsername = (
  name: FirstAndLastName,
): string => {
  if (!name.firstName && !name.lastName) {
    return '';
  }
  return `${name.firstName}.${name.lastName}`
    .toLowerCase()
    .replace(/[^a-z0-9_\.]/g, '')
    .replace(/^\.+|\.+$/g, '');
};

export const isApplePrivateRelayEmail = (email: string): boolean => {
  return email.endsWith('privaterelay.appleid.com');
};
